import createApi from 'api/createApi';

export const tags = {
	collectionsList: 'mw/knowledge-base-collections/list',
	collectionsDetail: 'mw/knowledge-base-collections/detail',
};

export const knowledgeBaseCollectionsApi = createApi({
	reducerPath: 'mw/knowledgeBaseCollectionsApi',
	tagTypes: Object.values(tags),
	endpoints: (builder) => ({
		collectionsList: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/knowledge-base-collections/',
			}),
			providesTags: [tags.collectionsList],
		}),
		collectionDetail: builder.query({
			query: (collectionId) => ({
				method: 'GET',
				url: `/mw/knowledge-base-collections/${collectionId}/`,
			}),
			providesTags: [tags.collectionsDetail],
		}),
		createCollection: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/knowledge-base-collections',
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.collectionsList],
		}),
		updateCollection: builder.mutation({
			query: ({ collectionId, ...body }) => ({
				method: 'PATCH',
				url: `/mw/knowledge-base-collections/${collectionId}`,
				body,
				jsonType: true,
			}),
			invalidatesTags: [tags.collectionsList, tags.collectionsDetail],
		}),
		deleteCollection: builder.mutation({
			query: (collectionId) => ({
				method: 'DELETE',
				url: `/mw/knowledge-base-collections/${collectionId}/`,
			}),
			invalidatesTags: [tags.collectionsList],
		}),
		addCollectionItem: builder.mutation({
			query: ({ collectionId, itemId }) => ({
				method: 'POST',
				url: `/mw/knowledge-base-collections/${collectionId}/item`,
				body: {
					item_id: itemId,
				},
				jsonType: true,
			}),
			invalidatesTags: [tags.collectionsList],
		}),
		removeCollectionItem: builder.mutation({
			query: ({ collectionId, collectionItemId }) => ({
				method: 'DELETE',
				url: `/mw/knowledge-base-collections/${collectionId}/item/${collectionItemId}/`,
			}),
			invalidatesTags: [tags.collectionsList],
		}),
	}),
});

export const {
	collectionsList,
	collectionDetail,
	createCollection,
	updateCollection,
	deleteCollection,
	addCollectionItem,
	removeCollectionItem,
} = knowledgeBaseCollectionsApi.endpoints;

export default knowledgeBaseCollectionsApi;
